import "../index.css";
import React from "react";
import Header from "./Header";
import Second from "./Second";
import Third from "./Third";

const Home = () => {
  return (
    <div className="main-container">
      <div className="first-container">
        <Header />
        <div className="hero-body">
          <div className="hero-text">
            <h1 className="hero-name">
              Raghad
              <br />
              al-Abboodi
            </h1>
            <p className="hero-tagline">
              Founder &amp; Director of She Codes Too. Passionate about
              education, young people, and empowering women to build careers and
              achieve economic independence. Speaker at Chatham House ·
              University of Bristol Alumni Award 2025.
            </p>
            <div className="hero-icons">
              <a
                href="https://github.com/raghadhav/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <div className="icon-class">
                  <img src="img/github.svg" className="icons" alt="GitHub" />
                </div>
              </a>
              <a
                href="https://www.linkedin.com/in/raghadhav/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <div className="icon-class">
                  <img
                    src="img/linkedin.svg"
                    className="icons"
                    alt="LinkedIn"
                  />
                </div>
              </a>
            </div>
          </div>
          <div className="hero-image">
            <picture>
              <source srcSet="img/raghad-picture.webp" type="image/webp" />
              <img src="img/raghad-picture.png" alt="Raghad al-Abboodi" />
            </picture>
          </div>
        </div>
      </div>
      <div className="section-wrapper">
        <div className="section">
          <Third />
        </div>
        <div className="section">
          <Second />
        </div>
      </div>
    </div>
  );
};

export default Home;
